import React from "react";
import ReactDom from "react-dom";
import { NotificationManager } from "react-notifications";
import { NavItem, Dropdown } from "react-bootstrap";
import Materialicon from "../helpers/Materialicon";

class NotificationsDropdown extends React.Component {

	state = {
		notifications: [],
	}

	render() {
		const { notifications } = this.state;
		const hasNotifications = notifications && Array.isArray(notifications) && notifications.length > 0;
		return (
			<div id="notifications-dropdown">
				<Dropdown id="notifications-dropdown-toggle">
					<Dropdown.Toggle noCaret>
						<Materialicon icon="add_alert"/>
						{hasNotifications ? 
							<span className="badge danger">{notifications.length}</span>
							: 
							null 
						}
					</Dropdown.Toggle> 
					<Dropdown.Menu>
						{ hasNotifications ? 
							<React.Fragment>
								<li className="notifications-title">
									<i className="material-icons"> add_alert </i>
									<span>Notifications</span>
								</li>
								<li>
									<ul className="notifications">
										{notifications.map((item)=>(
											<li key={item.id} className="single-notification">
												<a href="/not-found.html">
													<div className="media">
														<div className="media-left notification-img">
															<img src="https://www.brandeps.com/icon-download/U/User-01.svg" alt=""/>
														</div>
														<div className="media-body notification-content">
															<b>{item.name}</b>
															<p>{item.message.length > 32 ? `${item.message.substring(1,32)}...` : item.message}</p>
															<span>06 Mar 2018 03:30 PM</span>
														</div>
													</div>												
												</a>
											</li>
										))}
									</ul>
								</li>
							</React.Fragment>
							: 
							<li className="no-notification"><i className="material-icons">warning</i><span>You dont have notifications!</span></li>
						}
					</Dropdown.Menu>
				</Dropdown>
			</div>
		);
	}
}
export default NotificationsDropdown;


// WEBPACK FOOTER //
// ./src/components/navigation/NotificationsDropdown.js